import { render, staticRenderFns } from "./properties-list.vue?vue&type=template&id=717bd44a&scoped=true&"
import script from "./properties-list.vue?vue&type=script&lang=js&"
export * from "./properties-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717bd44a",
  null
  
)

export default component.exports